export default "__VITE_ASSET__CD6rd8N___"